// for converting ft/s to mph
const MPH_CONVERSION_FACTOR = 1.467;
// for converting ft/s to kph
const KPH_CONVERSION_FACTOR = 0.912;
// for converting ft to m
const METERS_CONVERSION_FACTOR = 3.281;
// for converting ft to km
const KM_CONVERSION_FACTOR = 3281;
// for converting ft to mi
const MI_CONVERSION_FACTOR = 5280;

const IMPERIAL_KEY = 'imp';
const METRIC_KEY = 'met';

const getSpeedConversionFactorForKey = (key) => (key === IMPERIAL_KEY ? MPH_CONVERSION_FACTOR : KPH_CONVERSION_FACTOR);
const getDistanceConversationFactorForKey = (key) => (key === IMPERIAL_KEY ? 1 : METERS_CONVERSION_FACTOR);
const getTotalDistanceConversionFactorForKey = (key) =>
    key === IMPERIAL_KEY ? MI_CONVERSION_FACTOR : KM_CONVERSION_FACTOR;

const isPuckAndPlayerTrackingPage = () => window.location.pathname.includes('performance-stats');

export default {
    IMPERIAL_KEY,
    METRIC_KEY,
    getSpeedConversionFactorForKey,
    getDistanceConversationFactorForKey,
    getTotalDistanceConversionFactorForKey,
    isPuckAndPlayerTrackingPage,
};
